var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParticipantShiftsTableRowActions } from '../../../../ui/features/shift-details/components/participant-details-tables/ParticipantShiftsTableRowActions';
import { useShiftParticipantActions } from '../../../../ui/features/shift/hooks/useShiftParticipantActions';
import { VolunteeringHoursActions } from '../../../../ui/features/time-tracking/components/VolunteeringHoursActions';
import { VolunteeringHoursAndStatus } from '../../../../ui/features/time-tracking/components/VolunteeringHoursAndStatus';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { Box, Typography } from '@mui/material';
import React from 'react';
export function useParticipantShiftsTableColumns({ fetchReload, }) {
    const { t } = useMissionsTranslation();
    const { handleAddHours, handleDenyHours, handleApproveHours } = useShiftParticipantActions();
    return [
        {
            headerLabel: t('shifts.volunteerShiftsTable.shiftDate'),
            cellFunction: (row) => {
                const startTime = new Date(row.columns.startTime);
                const stopTime = new Date(row.columns.stopTime);
                return (React.createElement(Box, { sx: {
                        display: 'flex',
                        whiteSpace: 'nowrap',
                        flexDirection: 'column',
                        gap: 1,
                    } },
                    React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' } },
                        React.createElement(Typography, { variant: 'subtitle2', "data-test": 'date' }, t('date', { value: startTime }))),
                    React.createElement(Typography, { sx: { color: (theme) => theme.palette.grey[700] }, variant: 'overline', "data-test": 'time' },
                        t('time', { value: startTime }),
                        " - ",
                        t('time', { value: stopTime }))));
            },
            tableCellSx: { maxWidth: 218 },
        },
        {
            headerLabel: t('shifts.volunteerShiftsTable.countyName'),
            cellFunction: (row) => (React.createElement(Typography, { variant: 'body2', sx: {
                    wordBreak: 'break-word',
                } }, row.columns.countyName)),
            tableCellSx: { maxWidth: 298 },
        },
        {
            headerLabel: t('shifts.volunteerShiftsTable.hoursWithStatus'),
            cellFunction: (row) => (React.createElement(VolunteeringHoursAndStatus, { t: t, participation: row, shiftParticipantId: row.id, hoursStatus: row.columns.hoursStatus, hours: row.columns.hours })),
            tableCellSx: { maxWidth: 150 },
        },
        {
            headerLabel: t('shifts.volunteerShiftsTable.hourActions'),
            cellFunction: (row) => {
                return (React.createElement(VolunteeringHoursActions, { participation: row, onAddHours: (addHoursParams) => __awaiter(this, void 0, void 0, function* () {
                        yield handleAddHours(addHoursParams);
                        return fetchReload();
                    }), missionOrganizationSharing: row.columns.organizationSharing }));
            },
            tableCellSx: { maxWidth: 124 },
        },
        {
            headerLabel: t('shifts.volunteerShiftsTable.actions'),
            cellFunction: (row) => (React.createElement(ParticipantShiftsTableRowActions, { row: row, fetchReload: fetchReload, handleApproveHours: handleApproveHours, handleDenyHours: handleDenyHours })),
            tableCellSx: { maxWidth: 219 },
        },
    ];
}
